var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "matrix(20.1026 0 0 20.1026 -11.3152 -11.3408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.25 4.367 1.117-1.117 18.383 18.383-1.117 1.117zm9.92 5.388 3.076 3.075c-.043-.802-.381-1.559-.949-2.127s-1.325-.906-2.127-.948zm-.34 6.491-3.075-3.076c.042.802.38 1.559.948 2.127s1.325.906 2.127.949z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 17.875c-.75 0-1.49-.173-2.162-.505-.672-.333-1.259-.816-1.714-1.412-.455-.597-.766-1.29-.909-2.026-.144-.736-.115-1.495.083-2.219l-3.508-3.508c-1.432 1.312-2.797 3.025-3.977 4.795 1.341 2.234 3.176 4.532 5.088 5.849 2.193 1.51 4.577 2.276 7.087 2.276 1.372.001 2.733-.236 4.024-.701l-2.723-2.722c-.42.115-.853.173-1.289.173zm0-9.75c.75 0 1.49.173 2.162.506.672.332 1.259.815 1.714 1.412.455.596.766 1.289.909 2.025.144.736.115 1.495-.083 2.219l3.589 3.588c1.48-1.333 2.847-3.126 3.897-4.875-1.34-2.205-3.195-4.497-5.139-5.831-2.22-1.522-4.596-2.294-7.061-2.294-1.357.002-2.702.248-3.972.726l2.697 2.697c.42-.115.852-.173 1.287-.173z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-disabled.5dcd30ed9e940167b3a12acf0fc0752f.svg";